import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BathtubShowerIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BathtubShowerIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M6.71565 19.9775C6.48111 19.9775 6.2714 19.8384 6.18138 19.6213C6.12153 19.4793 6.12104 19.3216 6.17992 19.1785C6.23053 19.055 6.31957 18.9547 6.43489 18.8915C3.84138 17.6438 2.17822 15.0153 2.17822 12.1318C2.17822 11.8126 2.43806 11.5527 2.75775 11.5527H4.11971V9.20836C4.11971 8.88916 4.37955 8.62931 4.69924 8.62931H7.16721C7.4869 8.62931 7.74674 8.88916 7.74674 9.20836V10.5844C7.74674 10.9036 7.4869 11.1635 7.16721 11.1635C6.84752 11.1635 6.5872 10.9036 6.5872 10.5844V9.78836H5.27877V11.5527H11.3533V7.93836C11.3533 5.97741 12.9596 4.38239 14.9336 4.38239C16.8508 4.38239 18.3952 5.86746 18.4867 7.77975C20.563 8.061 22.1113 9.76503 22.1823 11.8632C22.1823 12.0335 22.1249 12.1756 22.012 12.2885C21.9215 12.4121 21.7386 12.4588 21.612 12.4588H14.2514C14.103 12.4588 13.9614 12.3984 13.8519 12.2885C13.7468 12.1834 13.6816 12.0218 13.6816 11.8661C13.7279 9.80395 15.2956 8.06488 17.3452 7.78071C17.2537 6.52727 16.1905 5.52198 14.9336 5.52198C13.5882 5.52198 12.4934 6.60609 12.4934 7.93836V19.0618C12.4934 19.3761 12.2379 19.6311 11.9236 19.6311L9.67409 19.6272C9.12473 19.6272 8.57781 19.5678 8.0484 19.4501L6.93898 19.9328C6.86842 19.9629 6.79301 19.9775 6.71565 19.9775ZM3.36306 12.7108C3.65842 15.9486 6.40959 18.4691 9.6741 18.4691H11.3533V12.7108H3.36306ZM20.9508 11.3201C20.651 9.90223 19.3952 8.88429 17.9203 8.88429C16.4683 8.88429 15.2134 9.90126 14.8918 11.3201H20.9508Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.3904 7.86829C18.3434 5.98701 16.815 4.48199 14.9337 4.48199C13.0053 4.48199 11.4533 6.03404 11.4533 7.93883V11.6526H5.17889V9.68886H6.68692V10.5848C6.68692 10.8499 6.90183 11.0647 7.16731 11.0647C7.4322 11.0647 7.64711 10.8499 7.64711 10.5848V9.20903C7.64711 8.94403 7.4322 8.72919 7.16731 8.72919H4.69909C4.4342 8.72919 4.21929 8.94403 4.21929 9.20903V11.6526H2.75763C2.49274 11.6526 2.27783 11.8674 2.27783 12.1324C2.27783 15.145 4.08867 17.7423 6.67851 18.8942L6.53102 18.9559C6.28598 19.0581 6.17101 19.3392 6.27334 19.5837C6.3498 19.7678 6.52801 19.8786 6.71581 19.8786C6.77783 19.8786 6.84044 19.8666 6.90063 19.8414L8.06974 19.3528C8.58628 19.4675 9.12325 19.5285 9.67408 19.5285H11.9056C11.9119 19.5288 11.9172 19.5322 11.9236 19.5322C12.1822 19.5322 12.3939 19.3206 12.3939 19.0619V7.93884C12.3939 6.5514 13.5462 5.42263 14.9337 5.42263C16.2976 5.42263 17.4028 6.52788 17.4498 7.86829C15.4275 8.10345 13.8284 9.77308 13.7814 11.866C13.7814 11.9836 13.8284 12.1247 13.9225 12.2187C14.0165 12.3128 14.1341 12.3598 14.2516 12.3598H21.6122C21.7298 12.3598 21.8709 12.3128 21.9414 12.2187C22.0355 12.1247 22.0825 12.0071 22.0825 11.866C22.012 9.77308 20.4129 8.10345 18.3904 7.86829ZM3.25488 12.6122H11.4533V18.5688H9.67407C6.28597 18.5688 3.5011 15.9381 3.25488 12.6122ZM14.769 11.4192C15.0513 9.91418 16.3446 8.78541 17.9202 8.78541C19.4957 8.78541 20.8126 9.91418 21.0713 11.4192H14.769Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.4038 14.9049C15.0894 14.9049 14.834 14.65 14.834 14.3356V13.8179C14.834 13.5036 15.0894 13.2486 15.4038 13.2486C15.7181 13.2486 15.9741 13.5036 15.9741 13.8179V14.3356C15.9741 14.65 15.7181 14.9049 15.4038 14.9049Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.4039 13.3472C15.1452 13.3472 14.9336 13.5589 14.9336 13.8176V14.3349C14.9336 14.5936 15.1452 14.8053 15.4039 14.8053C15.6625 14.8053 15.8742 14.5936 15.8742 14.3349V13.8176C15.8742 13.5589 15.6626 13.3472 15.4039 13.3472Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.9204 14.9049C17.606 14.9049 17.3501 14.65 17.3501 14.3356V13.8179C17.3501 13.5036 17.606 13.2486 17.9204 13.2486C18.2347 13.2486 18.4902 13.5036 18.4902 13.8179V14.3356C18.4902 14.65 18.2347 14.9049 17.9204 14.9049Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.9201 13.3472C17.6614 13.3472 17.4497 13.5589 17.4497 13.8176V14.3349C17.4497 14.5936 17.6614 14.8053 17.9201 14.8053C18.1787 14.8053 18.3903 14.5936 18.3903 14.3349V13.8176C18.3903 13.5589 18.1787 13.3472 17.9201 13.3472Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.4599 14.9049C20.1456 14.9049 19.8896 14.65 19.8896 14.3356V13.8179C19.8896 13.5036 20.1456 13.2486 20.4599 13.2486C20.7743 13.2486 21.0302 13.5036 21.0302 13.8179V14.3356C21.0302 14.65 20.7743 14.9049 20.4599 14.9049Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.46 13.3472C20.2014 13.3472 19.9897 13.5589 19.9897 13.8176V14.3349C19.9897 14.5936 20.2014 14.8053 20.46 14.8053C20.7187 14.8053 20.9304 14.5936 20.9304 14.3349V13.8176C20.9304 13.5589 20.7187 13.3472 20.46 13.3472Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.6504 17.0446C16.336 17.0446 16.0801 16.7896 16.0801 16.4753V15.9576C16.0801 15.6432 16.336 15.3882 16.6504 15.3882C16.9647 15.3882 17.2206 15.6432 17.2206 15.9576V16.4753C17.2206 16.7896 16.9647 17.0446 16.6504 17.0446Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.6505 15.4869C16.3918 15.4869 16.1802 15.6986 16.1802 15.9572V16.4746C16.1802 16.7332 16.3918 16.9449 16.6505 16.9449C16.9091 16.9449 17.1208 16.7332 17.1208 16.4746V15.9572C17.1208 15.6986 16.9091 15.4869 16.6505 15.4869Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.1899 17.0446C18.8756 17.0446 18.6201 16.7896 18.6201 16.4753V15.9576C18.6201 15.6432 18.8756 15.3882 19.1899 15.3882C19.5042 15.3882 19.7602 15.6432 19.7602 15.9576V16.4753C19.7602 16.7896 19.5042 17.0446 19.1899 17.0446Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.1901 15.4869C18.9314 15.4869 18.7197 15.6986 18.7197 15.9572V16.4746C18.7197 16.7332 18.9314 16.9449 19.1901 16.9449C19.4488 16.9449 19.6604 16.7332 19.6604 16.4746V15.9572C19.6604 15.6986 19.4488 15.4869 19.1901 15.4869Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BathtubShowerIcon;
